export type MentorBase = {
  id: string;
  slug: string;
  first_name: string;
  last_name: string;
};



export type MentorSkillPreview = {
  highlight: boolean;
  skill: {
    name: string;
    slug: string | null;
    category?: { id?: string | null; name: string; icon?: string | null } | null;
  };
};

export type MentorPreview = MentorBase & {
  headline?: string | null;
  profile_photo?: {
    id: string;
    filename_disk: string;
  } | null;
  years_experience?: number | null;
  hourly_rate?: number | null;
  location?: string | null;
  mentor_skills?: MentorSkillPreview[];
};

export type MentorFull = MentorPreview & {
  bio?: string | null;
  hourly_rate?: number | null;
  location?: string | null;
  languages?: string[] | null;
  travel_distance?: number | null;
  availability_note?: string | null;

  mentor_skills?: (MentorSkillPreview & { level: string })[];
};

export function getMentorDisplayName(mentor: Pick<MentorBase, "first_name" | "last_name">): string {
  const first = mentor.first_name?.trim() ?? "";
  const last = mentor.last_name?.trim() ?? "";
  return `${first} ${last}`.trim();
}
